export default class MobileNavigation {
	constructor() {
		const buttons: NodeListOf<HTMLElement> = document.querySelectorAll('.toggle-navigation');
		buttons.forEach((button: HTMLElement) => {
			button.addEventListener('click', () => MobileNavigation.toggleNavigation());
		});
	}

	private static toggleNavigation(): void {
		if (document.body.classList.contains('navigation-is-open')) {
			document.body.classList.remove('navigation-is-open');
		} else {
			document.body.classList.add('navigation-is-open');
		}
	}
}
